import * as types from './constants';

// Remove Campaign Users
export const removeCampaignUsersRequest = data => (
  { type: types.REMOVE_CAMPAIGN_USERS_REQUEST, payload: data }
);

export const removeCampaignUsersDone = data => (
  { type: types.REMOVE_CAMPAIGN_USERS_DONE, payload: data }
);

export const removeCampaignUsersFailed = errors => (
  { type: types.REMOVE_CAMPAIGN_USERS_FAILED, payload: errors }
);